// extracted by mini-css-extract-plugin
export var actionButton = "_kd-0";
export var fileInput = "_kd-2";
export var paperclip = "_kd-1";